<template>
  <div class="p-seo__mobilefriendly">
    <div class="l-block__header">
      <TitleSub level="h3">
        <span class="title">モバイルフレンドリー判定</span>
      </TitleSub>
    </div>
    <Loading v-if="isLoading" variant="inline" />
    <Error v-else-if="isError" variant="inline" size="sm">
      <template slot="title">
        データがありません。
      </template>
    </Error>
    <div v-else class="flex" :class="status">
      <span class="label">{{ title[status] }}</span>
      <span class="result">{{ data.score }}</span>
      <span class="bold">/ 100</span>
      <span class="comment">
        {{ description[status] }}
      </span>
    </div>
  </div>
</template>

<script>
import Error from '@/components/Error';
import Loading from '@/components/Loading';
import TitleSub from '@/components/TitleSub';
import utils from '@/utils';

export default {
  props: ['data', 'isLoading'],

  components: {
    Error,
    Loading,
    TitleSub
  },

  data() {
    return {
      title: {
        good: 'Good',
        fair: 'Fair',
        poor: 'Poor'
      },
      description: {
        good: 'モバイルに最適化されています',
        fair: 'モバイルフレンドリーです',
        poor: 'モバイルフレンドリーではありません'
      }
    };
  },

  computed: {
    status() {
      if (this.isError) {
        return '';
      }
      if (this.data.score >= 80) {
        return 'good';
      } else if (this.data.score >= 60) {
        return 'fair';
      } else {
        return 'poor';
      }
    },
    isError() {
      return utils.isEmpty(this.data.score);
    }
  }
};
</script>
